import { Controller } from "@hotwired/stimulus";

// One open panel at a time. A button names its panel with aria-controls;
// documentation/development_manual/navbar.md has the contract.
export default class extends Controller {
  static targets = ["button", "panel"];

  toggle(event) {
    const button = event.currentTarget;
    const opening = button.getAttribute("aria-expanded") !== "true";

    this.closeAll();
    if (opening) {
      this.#set(button, true);
    }
  }

  closeOutside(event) {
    const inside = [...this.buttonTargets, ...this.panelTargets].some(
      (element) => element.contains(event.target),
    );

    if (!inside) {
      this.closeAll();
    }
  }

  closeAll() {
    this.buttonTargets.forEach((button) => this.#set(button, false));
  }

  #set(button, open) {
    button.setAttribute("aria-expanded", open);
    document.getElementById(button.getAttribute("aria-controls")).hidden =
      !open;
  }
}
